(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sleep365-video-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var HLS_SRC = 'https://cdn.jsdelivr.net/npm/hls.js@1.5.13/dist/hls.min.js';
    var hlsPromise = null;

    function loadHls() {
      if (window.Hls) { return Promise.resolve(window.Hls); }
      if (hlsPromise) { return hlsPromise; }
      hlsPromise = new Promise(function (resolve, reject) {
        var el = document.createElement('script');
        el.src = HLS_SRC;
        el.onload = function () { resolve(window.Hls); };
        el.onerror = reject;
        document.head.appendChild(el);
      });
      return hlsPromise;
    }

    function attachSource(video) {
      if (video.dataset.s365Loaded === 'true') { return; }
      video.dataset.s365Loaded = 'true';

      var sources = Array.prototype.slice.call(video.querySelectorAll('source[data-src]'));
      if (!sources.length) { return; }

      var hlsSource = sources.filter(function (s) {
        return (s.getAttribute('type') || '').toLowerCase().indexOf('mpegurl') !== -1;
      })[0];

      if (hlsSource) {
        var url = hlsSource.getAttribute('data-src');
        if (video.canPlayType('application/vnd.apple.mpegurl')) {
          hlsSource.src = url;
          hlsSource.removeAttribute('data-src');
          video.load();
        } else {
          loadHls().then(function (Hls) {
            if (Hls && Hls.isSupported()) {
              // capLevelToPlayerSize: pick the rendition matching the displayed size (avoids a soft/low-res stream)
              var instance = new Hls({ capLevelToPlayerSize: true });
              instance.loadSource(url);
              instance.attachMedia(video);
            } else {
              hlsSource.src = url;
              hlsSource.removeAttribute('data-src');
              video.load();
            }
          }).catch(function () {});
        }
        return;
      }

      sources.forEach(function (s) {
        s.src = s.getAttribute('data-src');
        s.removeAttribute('data-src');
      });
      video.load();
    }

    function play(video) {
      var promise = video.play();
      if (promise && promise.catch) { promise.catch(function () {}); }
    }

    function initSection(root) {
      if (!root || root.dataset.s365Init === 'true') { return; }
      root.dataset.s365Init = 'true';

      var videos = Array.prototype.slice.call(root.querySelectorAll('[data-s365-video]'));
      var muteBtns = Array.prototype.slice.call(root.querySelectorAll('[data-s365-mute]'));
      var muted = true;
      var loaded = false;

      if (!videos.length) { return; }

      // Desktop (>= 1025px) shows the "split" layout; mobile/tablet (<= 1024px) shows "feature".
      var mobileMQ = window.matchMedia('(max-width: 1024px)');

      function activeVideo() {
        var wantSplit = !mobileMQ.matches;
        var found = null;
        videos.forEach(function (v) {
          var isSplit = v.getAttribute('data-layout') === 'split';
          if ((wantSplit && isSplit) || (!wantSplit && !isSplit)) { found = v; }
        });
        return found || videos[0];
      }

      function sync() {
        var active = activeVideo();
        videos.forEach(function (v) {
          if (v === active) {
            if (loaded) {
              attachSource(v);
              v.muted = muted;
              play(v);
            }
          } else if (typeof v.pause === 'function') {
            v.pause();
          }
        });
      }

      // The source file is heavy, so it must not be requested on page load (it would
      // tank PageSpeed/GTmetrix page-weight and load-time scores). Instead we only
      // swap the data-* attributes into a real <source>/src the first time the
      // visitor actually does something on the page.
      var loadTriggers = [
        [document, 'mousemove'],
        [document, 'touchstart'],
        [document, 'keydown'],
        [document, 'click'],
        [document, 'wheel'],
        
      ];

      function triggerLoad() {
        if (loaded) { return; }
        loaded = true;
        loadTriggers.forEach(function (pair) {
          pair[0].removeEventListener(pair[1], triggerLoad);
        });
        var active = activeVideo();
        if (active) {
          attachSource(active);
          active.muted = muted;
          play(active);
        }
      }

      loadTriggers.forEach(function (pair) {
        pair[0].addEventListener(pair[1], triggerLoad, { passive: true });
      });

      function updateIcons() {
        muteBtns.forEach(function (btn) {
          btn.setAttribute('aria-pressed', muted ? 'false' : 'true');
          btn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
          var on = btn.querySelector('[data-icon="on"]');
          var off = btn.querySelector('[data-icon="off"]');
          if (on) { on.style.display = muted ? 'none' : ''; }
          if (off) { off.style.display = muted ? '' : 'none'; }
        });
      }

      muteBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          muted = !muted;
          triggerLoad();
          var active = activeVideo();
          if (active) {
            active.muted = muted;
            if (!muted) { play(active); }
          }
          updateIcons();
        });
      });

      if (mobileMQ.addEventListener) { mobileMQ.addEventListener('change', sync); }
      else if (mobileMQ.addListener) { mobileMQ.addListener(sync); }

      updateIcons();
      sync();
    }

    function initAll() {
      document.querySelectorAll('[data-s365vt]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-s365vt]');
      if (root) { initSection(root); }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
